__turbopack_context__.v({
  "reviewCard": "review-card-module-scss-module__R9m0GG__reviewCard",
  "reviewCard__horizontal": "review-card-module-scss-module__R9m0GG__reviewCard__horizontal",
  "reviewCard_content": "review-card-module-scss-module__R9m0GG__reviewCard_content",
  "reviewCard_date": "review-card-module-scss-module__R9m0GG__reviewCard_date",
  "reviewCard_description": "review-card-module-scss-module__R9m0GG__reviewCard_description",
  "reviewCard_description__full": "review-card-module-scss-module__R9m0GG__reviewCard_description__full",
  "reviewCard_info": "review-card-module-scss-module__R9m0GG__reviewCard_info",
  "reviewCard_rating": "review-card-module-scss-module__R9m0GG__reviewCard_rating",
  "reviewCard_star": "review-card-module-scss-module__R9m0GG__reviewCard_star",
  "reviewCard_title": "review-card-module-scss-module__R9m0GG__reviewCard_title",
  "reviewCard_top": "review-card-module-scss-module__R9m0GG__reviewCard_top",
  "reviewCard_userLocation": "review-card-module-scss-module__R9m0GG__reviewCard_userLocation",
});
